import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {acquireAccessToken} from './ApiService';
import {msalInstance} from 'index';
import {Bookmark, PbiReport, ReportsResponse} from 'core/slices/models';

const rawBaseQuery = fetchBaseQuery({baseUrl: '/api/v1'});

const authBaseQuery: typeof rawBaseQuery = async (args, api, extraOptions) => {
  let headers: Headers | undefined;
  let modifiedArgs = args as any;
  try {
    const token = await acquireAccessToken(msalInstance);
    if (typeof args === 'string') {
      modifiedArgs = {url: args};
    }
    headers = new Headers((modifiedArgs.headers as any) || undefined);
    if (token) headers.set('Authorization', `Bearer ${token}`);
    headers.set('Accept', 'application/json');
    modifiedArgs.headers = headers;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Token acquisition failed for reportsApiSlice', err);
  }
  return rawBaseQuery(modifiedArgs, api, extraOptions);
};

export const reportsApiSlice = createApi({
  reducerPath: 'reportsApi',
  baseQuery: authBaseQuery,
  tagTypes: ['ProjectReport', 'Bookmark'],
  endpoints: builder => ({
    getProjectReports: builder.query<PbiReport[], string>({
      query: projectKey => `projects/${projectKey}/reports`,
      transformResponse: (response: ReportsResponse[]): PbiReport[] => {
        const flat: PbiReport[] = [];
        response.forEach(workspace => {
          workspace.reports.forEach(r => {
            flat.push({...r, workspaceId: workspace.workspaceId});
          });
        });
        return flat;
      },
      providesTags: (result, error, projectKey) => [
        {type: 'ProjectReport', id: projectKey},
      ],
    }),
    // getBookmark: builder.query<
    //   Bookmark,
    //   { projectKey: string; reportId: string; bookmarkId: number }
    // >({
    //   query: ({projectKey, reportId, bookmarkId}) =>
    //     `projects/${projectKey}/reports/${reportId}/bookmarks/${bookmarkId}`,
    //   providesTags: (result, error, {bookmarkId}) => [
    //     {type: 'Bookmark', id: bookmarkId},
    //   ],
    // }),
    // addBookmark: builder.mutation<
    //   Bookmark,
    //   { projectKey: string; reportId: string; dto: Bookmark }
    // >({
    //   query: ({projectKey, reportId, dto}) => ({
    //     url: `projects/${projectKey}/reports/${reportId}/bookmarks`,
    //     method: 'POST',
    //     body: dto,
    //   }),
    //   invalidatesTags: (result, error, {projectKey}) => [
    //     {type: 'ProjectReport', id: projectKey},
    //   ],
    // }),
    // updateBookmark: builder.mutation<
    //   Bookmark,
    //   { projectKey: string; reportId: string; bookmarkId: number; dto: Bookmark }
    // >({
    //   query: ({projectKey, reportId, bookmarkId, dto}) => ({
    //     url: `projects/${projectKey}/reports/${reportId}/bookmarks/${bookmarkId}`,
    //     method: 'PUT',
    //     body: dto,
    //   }),
    //   invalidatesTags: (result, error, {projectKey, bookmarkId}) => [
    //     {type: 'Bookmark', id: bookmarkId},
    //     {type: 'ProjectReport', id: projectKey},
    //   ],
    // }),
    // deleteBookmark: builder.mutation<
    //   void,
    //   { projectKey: string; reportId: string; bookmarkId: number }
    // >({
    //   query: ({projectKey, reportId, bookmarkId}) => ({
    //     url: `projects/${projectKey}/reports/${reportId}/bookmarks/${bookmarkId}`,
    //     method: 'DELETE',
    //   }),
    //   invalidatesTags: (result, error, {projectKey, bookmarkId}) => [
    //     {type: 'Bookmark', id: bookmarkId},
    //     {type: 'ProjectReport', id: projectKey},
    //   ],
    // }),
  }),
});

export const {
  useGetProjectReportsQuery: useReportsGetProjectReportsQuery,
  // useGetBookmarkQuery: useReportsGetBookmarkQuery,
  // useAddBookmarkMutation: useReportsAddBookmarkMutation,
  // useUpdateBookmarkMutation: useReportsUpdateBookmarkMutation,
  // useDeleteBookmarkMutation: useReportsDeleteBookmarkMutation,
} = reportsApiSlice;
